import AllCourses from "../../../components/allCourses/AllCourses";
import OnTrackCoursesPage from "../../../components/onTrackCourses/index.jsx";
import PartnerInstitutionCoursesPage from "../../../components/partnerInstitutionCourses/index.jsx";
import { useLocation } from "react-router-dom";

const AllCoursesHome = () => {
  const location = useLocation();
  const urlParams = new URLSearchParams(location.search);
  const courseTab = urlParams.get('courseTab') || 'ontrack-courses';

  const renderContent = () => {
    switch (courseTab) {
      case 'ontrack-courses':
        return <OnTrackCoursesPage />;
      case 'partner-courses':
        return <PartnerInstitutionCoursesPage />;
      default:
        return <AllCourses />;
    }
  };

  return renderContent();
};

export default AllCoursesHome;
